import React ,{useEffect} from 'react';
import {Helmet} from "react-helmet";
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import MyAccounts from '../../components/MyAccount';
import BrandLogoSlider from '../../components/BrandLogoSlider';
import ActiveCatalogue from '../../components/ActiveCatalogue/ActiveCatalogue'
import * as AuthVerify from '../../lib/common';
import {useNavigate} from 'react-router-dom';

import './MyAccount.styles.css'; 

const MyAccount = () => {
	const navigate = useNavigate();

	useEffect(() => { 
		if(!AuthVerify.isUserLogedIn()){
			navigate('/login');
		}
	},[])
	return (
		<div>
			<Helmet>
				<title>My Account</title>
			</Helmet>
			<Header/>
            <ActiveCatalogue /> 
			<MyAccounts/>
			<BrandLogoSlider/>
			<Footer/>
		</div>
	); 
}; 

export default MyAccount;